export const FLAIR_ADDRESS_LISTS_BACKEND = {
  dev: 'http://localhost:3000',
  prod: 'https://api.flair.finance',
};
